import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { formValueSelector, clearFields } from 'redux-form'
import { accountsNames } from '../constants'
import FormField from '../../shared/newFormElements'

interface CCYFieldParams {
  ccy: string
  FormName: string
  name: string
  onChange: Function
  disabled: boolean
  debit: boolean
  credit: boolean
}

const CCYField = ({ FormName, name, ccy, debit, onChange, disabled, credit }: Partial<CCYFieldParams>) => {
  const dispatch = useDispatch()

  const currentCCY: string = useSelector((state) => formValueSelector(FormName)(state, name))

  return (
    // @ts-ignore
    <FormField
      customOnChange={(value) => {
        if (value !== currentCCY) {
          if (onChange) {
            onChange(value)
          } else {
            let fieldsToClear = []

            if (debit) {
              fieldsToClear = Object.keys(accountsNames.debit).reduce(
                (result, current) => [...result, accountsNames.debit[current]],
                [],
              )
            }

            if (credit) {
              fieldsToClear = [
                ...fieldsToClear,
                ...Object.keys(accountsNames.credit).reduce(
                  (result, current) => [...result, accountsNames.credit[current]],
                  [],
                ),
              ]
            }

            dispatch(clearFields(FormName, false, false, ...fieldsToClear))
          }
        }
      }}
      name={name}
      type="select"
      disabled={disabled}
      options={ccy}
      search
    />
  )
}

export default CCYField
